<template>
  <div class="detail-hd">
    <t-head></t-head>
    <div class="w1200 list-box">
      <t-navleft></t-navleft>
      <div class="innercont floatR">
        <div class="innercontT">
          <div class="innercontTL floatL" v-if="upNav.length!=0">
            :::<span>{{upNav.two}}</span>:::
          </div>
          <div class="innercontTL floatL" v-if="upNav.length==0">
            :::<span>&#12288;&#12288;&#12288;</span>:::
          </div>
          <div class="floatR innercontTR" v-if="upNav.length!=0">当前位置：<a href="/">首页</a><a
              href="">{{upNav.one?">>":""}}{{upNav.one}}</a>{{upNav.two?">>":""}}{{upNav.two}}</div>
          <div class="floatR innercontTR" v-if="upNav.length==0">当前位置：首页 >>&#12288; &#12288; &#12288; >>&#12288;
            &#12288; &#12288; </div>
          <div class="clear"></div>
        </div>
        <div class="articleC">
          <img class="userimg" v-if="archive.channel_id==17" :src="archive.image" alt="">
          <h2 class="articleCtit">{{archive.title}}</h2>
          <img class="articimg" v-if="archive.channel_id!=17 && archive.image" :src="archive.image" alt="">
          <div class="articleCcont" v-html="archive.content">
          </div>

          <!--占位-->
          <h2 class="articleCtit" style="margin-left: 30%"
            v-fill="{ fill:Object.keys(archive).length==0,height: '40px',width:'50%'}" pagination :autoplay="1"></h2>
          <br>
          <div v-for="n in 3" v-if="Object.keys(archive).length==0">
            <h4 class="articleCtit" style="margin-left: 6%"
              v-fill="{ fill:Object.keys(archive).length==0,height: '20px',width:'100%'}" pagination :autoplay="1"></h4>
            <li style="height: 10px"></li>
            <h4 class="articleCtit" style="" v-fill="{ fill:Object.keys(archive).length==0,height: '20px',width:'100%'}"
              pagination :autoplay="1"></h4>
            <li style="height: 10px"></li>
            <h4 class="articleCtit" style="" v-fill="{ fill:Object.keys(archive).length==0,height: '20px',width:'100%'}"
              pagination :autoplay="1"></h4>
            <li style="height: 10px"></li>
            <h4 class="articleCtit" style="" v-fill="{ fill:Object.keys(archive).length==0,height: '20px',width:'100%'}"
              pagination :autoplay="1"></h4>
            <li style="height: 10px"></li>
            <h4 class="articleCtit" style="" v-fill="{ fill:Object.keys(archive).length==0,height: '20px',width:'100%'}"
              pagination :autoplay="1"></h4>
            <li style="height: 10px"></li>
            <h4 class="articleCtit" style="" v-fill="{ fill:Object.keys(archive).length==0,height: '20px',width:'100%'}"
              pagination :autoplay="1"></h4>
            <li style="height: 20px"></li>
          </div>

        </div>
        <div class="" v-if="fileList.length>0">
          <h6 style="color: #c9302c">附件下载:</h6>
          <ul>
            <li v-for="(file,index ) in fileList"><a :href="file.url" target="_blank">{{file.filename}}</a> </li>
          </ul>
        </div>
      </div>
    </div>
    <t-foot></t-foot>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    name: "articledetail",
    data() {
      return {
        id: this.$route.query.aid,
        archive: {},
        upNav: [],
        fileList: [],
      }
    },
    created() {

    },
    mounted() {
      this.getArchive();
    },
    methods: {
      getArchive: async function() {
        let res = await this.$getJSON('zyyarchives/archiveDetail', {
          id: this.id
        });
        if (res.code == 1) {
          this.archive = res.data.archive;
          this.upNav = res.data.upNav;
          this.fileList = res.data.fileList;
        }
      },
      download: function(file){
        let _this = this;
        axios({
                method: 'GET',
                url: 'zyyarchives/download',
                params: {
                  id: this.id
                },
                responseType: 'blob'
              }).then(response => {
                console.log(response);
               if (response.data.type === 'application/octet-stream') {
                // 获取http头部的文件名信息，若无需重命名文件，将下面这行删去
                const fileName = response.headers['content-disposition'].split('=')[1]
                /* 兼容ie内核，360浏览器的兼容模式 */
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                  const blob = new Blob([response.data], { type: 'application/zip' })
                  window.navigator.msSaveOrOpenBlob(blob, fileName)
                } else {
                  /* 火狐谷歌的文件下载方式 */
                  const blob = new Blob([response.data], { type: 'application/zip' })
                  const url = window.URL.createObjectURL(blob)
                  const link = document.createElement('a') // 创建a标签
                  link.href = url
                  link.download = fileName // 文件重命名，若无需重命名，将该行删去
                  link.click()
                  URL.revokeObjectURL(url) // 释放内存
                }
                resolve(response)
              } else {
                const reader = new FileReader()
                reader.onload = function(event) {
                  const msg = JSON.parse(reader.result).data
                  _this.$errorMsg(message) // 将错误信息显示出来
                }
                reader.readAsText(response.data)
              }
              }).catch(error => _this.$errorMsg(error) )
      },

    }
  }
</script>

<style lang="scss">
  .list-box {
    background: #fff;
    padding: 20px 0;
    margin-top: 6px;
    overflow: hidden;

    .innercont {
      width: 950px;
      border: 1px solid #ddd;
      padding: 0 10px 20px;
      box-sizing: border-box;

      .innercontT {
        height: 68px;
        line-height: 68px;
        width: 100%;
        border-bottom: 1px solid #b2ddef;

        .innercontTL {
          line-height: 65px;
          font-size: 24px;
          color: #007ebf;
          border-bottom: 2px solid #007ebf;

          span {
            display: inline-block;
            margin: 0 8px;

          }
        }

        .innercontTR {
          font-size: 14px;
          color: #666;
        }

      }

      .articleC {
        padding: 10px 5px;

        .articimg {
          width: 100%;

        }

        .userimg {
          margin: 0 auto;
        }

        .articleCtit {
          font-size: 30px;
          text-align: center;
          line-height: 2;
        }

        .articleCcont {
          font-size: 20px;
          line-height: 1.8;
          text-indent: 2em;

          table {
            width: 100%;
          }
        }

        .articleCcont img {
          width: 100%;
        }

        .articleCcont table,
        td,
        th {
          text-align: center;
          border: 1px solid #999999;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/articledetail.vue